import React, { Component } from 'react';
import '../App.css'
import AuthService from '../Config/AuthService';

function lendernotfound(props)
{

    const logoutHandler =() =>{
        console.log("*****")
        // Stop session services
        AuthService.stopTokenRefresh();
        AuthService.stopHeartbeat();

        // End session and logout on server
        AuthService.endSession().catch(err => console.log('End session error:', err));
        AuthService.logOut().catch(err => console.log('Logout error:', err));

        localStorage.clear()
        props.history.push('/');
      }
      
    return (
            <div className="not_found_parent">
            <div className="not_found_child">
                <h1>Lender not mapped with client app!!!</h1>
                <a onClick={logoutHandler} style={{fontSize : "25px"}}>Back to Login</a>
            </div>
            </div>
        )
}
export default lendernotfound;
